function setCGFilterHeight() {
    const $cgFilter = $('.cg__filter')
    const $header = $('[x-data="header"]')
    if (!$cgFilter.length || !$header.length) return

    if ($(window).width() <= 1024) {
        $cgFilter.css({'height': 'auto', 'top': 0 })
        return
    }
    
    const headerHeight = $header.innerHeight()
    const headerHeightCSS = `calc(100vh - ${headerHeight}px)`
    const offsetTop = `${headerHeight}px`
    $cgFilter.css({'height': headerHeightCSS, 'top': offsetTop})
}

function initAccordions() {
    var acc = document.getElementsByClassName('cg__accordion');
    var i;
    for (i = 0; i < acc.length; i++) {
        acc[i].addEventListener('click', function() {
            this.classList.toggle('active');
            this.closest('.cg__product').classList.toggle('active');
            var panel = this.nextElementSibling;
            if (panel.style.maxHeight) {
                panel.style.maxHeight = null;
            } else {
                panel.style.maxHeight = panel.scrollHeight + "px";
            } 
        });
    }
}

function updateCGURL(query) {
    let url_params = new URLSearchParams(window.location.search)

    query.s ? url_params.set('q', query.s) : url_params.delete('q')

    const url_params_string = url_params.toString() ? `?${url_params.toString()}` : ''

    window.history.replaceState({}, '', `${window.location.origin}${window.location.pathname}${url_params_string}`)
}

function buildCGList(query) {
    let cgABC = [ '#', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z' ]
    let cgProducts = window.cgProducts

    cgProducts = [...new Map(cgProducts.map(product => [product['title'], product])).values()]

    if (query.s) {
        cgProducts = cgProducts.filter(product => {
            const search_keywords = product.search_keywords.map(search_keyword => search_keyword.trim())
            return product.title.toLowerCase().includes(query.s.toLowerCase()) 
                || product.skus.includes(query.s.toLowerCase()) 
                || search_keywords.includes(query.s.toLowerCase())
        })
    } 

    if (query.collections.length) {
        cgProducts = cgProducts.filter(product => {
            return query.collections.includes(product.collection)
        })
    }

    const $cgContentNode = $('.cg__content')

    let CGListHtml = '<ul>'

    if (cgProducts.length) {
        cgABC.forEach(letter => {
            const products = cgProducts.filter(product => {
                if (letter == '#') {
                    return !cgABC.includes(product.title.charAt(0).toUpperCase())
                } else {
                    return product.title.charAt(0).toUpperCase() == letter
                }
            }).sort((a,b) => (a.title > b.title) ? 1 : ((b.title > a.title) ? -1 : 0))

            if (products.length) {
                CGListHtml += '<li>'
                    CGListHtml += '<p class="cg__content-title">' + letter + '</p>'
                    CGListHtml += '<ul>'
                        products.forEach(prod => {
                            CGListHtml += '<li>'
                                CGListHtml += '<div class="cg__product">'
                                    CGListHtml += '<h3 class="cg__accordion">'
                                        CGListHtml += '<span>' + prod.title + '</span>'
                                        CGListHtml += '<span class="cg__icon"><img src="//cdn.shopify.com/s/files/1/0330/3299/4860/t/177/assets/faq-down.png?v=108779040617366874071666836244" width="28" height="15" alt="Care Guide arrow"></span>'
                                    CGListHtml += '</h3>'
                                    CGListHtml += '<div class="cg__product-content"><div class="cg__product-content-inner">'
                                        if (prod.basic_care) {
                                            CGListHtml += '<h4>Basic Care</h4>'
                                            CGListHtml += '<div>' + prod.basic_care + '</div>'
                                        }
                                        if (prod.pro_tip) {
                                            CGListHtml += '<h4>Pro Tip</h4>'
                                            CGListHtml += '<div>' + prod.pro_tip + '</div>'
                                        }
                                        CGListHtml += '<div class="cg__product-link"><a href="' + prod.url + '">View ' + prod.title + '</a></div>'
                                    CGListHtml += '</div></div>'
                                CGListHtml += '</div>'
                            CGListHtml += '</li>'
                        })
                    CGListHtml += '</ul>'
                CGListHtml += '</li>'
            }
        })
    } else {
        CGListHtml += '<li class="cg__noresults">No products found.</li>'
    }

    CGListHtml += '</ul>'

    $cgContentNode.html(CGListHtml)

    initAccordions()
}

function scrollToCGTop() {
    if ($(window).width() > 1024) {
        const $cgWrapper = document.querySelector('body')
        $cgWrapper.scrollIntoView()
    }
}

function updateBackToTop() {
    const backToTop = $('[data-cg-back-to-top]')
    const scrollPos = $(window).scrollTop()

    if (!scrollPos) {
        backToTop.fadeOut(200)
    } else {
        backToTop.fadeIn(200)
    }
}

function initialLoad(form) {
    const url_params = new URLSearchParams(window.location.search)

    if (!url_params.toString()) {
        form.trigger('change')
        return
    }
    
    const q = url_params.get('q')

    if (!q) {
        form.trigger('change')
        return
    }

    form.find('[data-cg-input]').val(q)
    form.trigger('change')
}

$(document).ready(function() {
    const $cg = {
        form: $('[data-cg-form]'),
        backToTop: $('[data-cg-back-to-top]')
    }

    updateBackToTop()
    $(document).scroll(updateBackToTop)

    $cg.backToTop.on('click', function(e) {
        e.preventDefault()
        const $cgWrapper = document.querySelector('body')
        $cgWrapper.scrollIntoView()
    })

    setCGFilterHeight()

    $(window).resize(setCGFilterHeight)

    $cg.form.on('change keyup', function() {
        const s = $(this).find('[data-cg-input]').val().trim()
        const collections = $(this).find('[data-collection]:checked').map((i, el) => {
            return el.value
        }).get()

        const query = {
            s: s,
            collections: collections
        }

        updateCGURL(query)
        buildCGList(query)
        scrollToCGTop()
    })

    initialLoad($cg.form)
})